import { axios } from "../axiosInstance";

export interface SecondmentCard {
  secId: number;
  firmId: number;
  title: string;
  companyName: string;
  companyType: string;
  companyNameSlug: string;
  logoName: string;
  placeLabel: string;
  excerpt: string;
  location: string;
}

export interface SecondmentChoice {
  value: string;
  label: string;
}

export interface SecondmentCatalogResult {
  mode: "firms" | "postings";
  redirect: { secId: number; firmId: number } | null;
  page: number;
  pageCount: number;
  total: number;
  items: SecondmentCard[];
  header: SecondmentCard | null;
  applicantPlace: string;
  options: {
    firms: { id: string; name: string }[];
    jurisdictions: SecondmentChoice[];
    regions: SecondmentChoice[];
  };
}

export interface SecondmentDetail {
  secId: number;
  firmId: number;
  positionTitle: string;
  companyName: string;
  companyType: string;
  companyNameSlug: string;
  logoName: string;
  programOverview: string;
  description: string;
  requirements: string;
  applicationInfo: string;
  location: string;
  duration: string;
  deadline: string;
  practices: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  contactId: number;
  contactSlug: string;
  alreadyApplied: boolean;
  applicantPlace: string;
}

export interface SecondmentActor {
  contactId: string;
  companyId: string;
  name: string;
  email: string;
  phone: string;
  firmName: string;
  title: string;
}

export interface SecondmentSaveResult {
  saved: boolean;
  errors?: string[];
}

function queryString(params: Record<string, string>): string {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      search.set(key, value);
    }
  });
  const text = search.toString();
  return text ? `?${text}` : "";
}

export async function getSecondmentCatalog(params: Record<string, string>): Promise<SecondmentCatalogResult> {
  const response = await axios.Get(`./publicSecondments${queryString({ view: "catalog", ...params })}`);
  return response.data as SecondmentCatalogResult;
}

export async function getSecondmentDetail(secId: string, firmId: string, countView: boolean, contactId: string, companyId: string): Promise<SecondmentDetail> {
  const response = await axios.Get(`./publicSecondments${queryString({ view: "detail", secId, firmId, countView: countView ? "1" : "", contactId, companyId })}`);
  return response.data as SecondmentDetail;
}

export async function submitSecondment(action: "apply" | "info", actor: SecondmentActor, fields: Record<string, string>): Promise<SecondmentSaveResult> {
  const response = await axios.Post("./publicSecondments", { action, ...actor, ...fields });
  return response.data as SecondmentSaveResult;
}
